import {observer} from 'mobx-react';
import {FormattedMessage} from 'react-intl';
import {withState} from 'shared/core';
import {EmployeeNameWithAvatar, Panel} from 'shared/components';
import Table from 'main/components/tables/components/Table';
import {Line} from 'rc-progress';
import _ from 'lodash';
import RevieweeListEmptyState from './RevieweesListEmptyState';
import AwaitingTag from '../../AwaitingTag';
import RevieweesContainerState from './state/RevieweesContainerState';

const COLOURS_BY_PERCENTAGE = [
  {
    minPercent: 0,
    colour: '#00B7B3',
  },
  {
    minPercent: 70,
    colour: '#FABA4F',
  }
];

const DaysSinceLastCheckIn = ({model}) => {
  const {daysSinceLastCheckin, totalDays} = model;

  if (daysSinceLastCheckin == null) return <FormattedMessage id='performance.NO_CHECK_INS'/>;

  const percentage = _.min([daysSinceLastCheckin * 100 / totalDays, 100]);
  const colour = _.findLast(COLOURS_BY_PERCENTAGE, c => percentage >= c.minPercent).colour;
  return (
    <div>
      <div className='table-cell align-middle'>
        <FormattedMessage id='DAYS_COUNT' values={{count: daysSinceLastCheckin}} />
      </div>
      <div style={{width: '100px'}} className='table-cell align-middle relative pl1'>
        <Line className='absolute' percent={percentage} strokeColor={colour} strokeWidth={3} trailWidth={3}/>
      </div>
    </div>
  );
};

const Reviewee = ({model}) => (
  <div className='flex align-items-middle'>
    <EmployeeNameWithAvatar employee={model.reviewee} size='sm'/>
    <div className='pl1'>
      <AwaitingTag status={model.status}/>
    </div>
  </div>
);

const COLUMNS = [
  {
    header: 'performance.Employee',
    width: 4,
    component: Reviewee
  },
  {
    header: 'performance.Suggested Frequency',
    width: 4,
    render: ({frequency}) => <FormattedMessage id={frequency}/>
  },
  {
    header: 'performance.DAYS_SINCE_LAST_CHECK_IN',
    width: 4,
    component: DaysSinceLastCheckIn
  }
];

const RevieweesContainerWithState = observer(({uiState}) => {
  const {pairs} = uiState;

  if (_.isEmpty(pairs)) return <RevieweeListEmptyState/>;

  return (
    <div className='Container'>
      <Panel>
        <Table
          columns={COLUMNS}
          models={pairs}
          showLinks={false}
          showRoute={({reviewee}) => `/reviewees/${reviewee.id}`}
        />
      </Panel>
    </div>
  );
});

export default withState(RevieweesContainerWithState, RevieweesContainerState);
